import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

/* Stile Design System per il TextField MUI: bordo/radius/focus come Input e AppSelect. */
const DS_TEXTFIELD_SX = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 'var(--radius-sm)',
    backgroundColor: 'var(--color-surface)',
    fontSize: 'var(--font-size-body)',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--color-input-border)',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--color-primary-border)',
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--color-teal)',
    borderWidth: '1px',
  },
  '& .MuiInputLabel-root.Mui-focused': { color: 'var(--color-teal)' },
};

/**
 * DatePicker — wrapper di `@mui/x-date-pickers/DatePicker`.
 *
 * Default opinionati:
 * - format `DD/MM/YYYY` (locale italiano è già configurato globalmente via
 *   `LocalizationProvider` in `src/main.jsx`),
 * - `slotProps.textField.fullWidth=true`, `size="small"`,
 *   `variant="outlined"` per allineare ai form Bootstrap legacy,
 * - `value` accetta `Date | dayjs | string | null`; viene normalizzato a dayjs.
 *
 * `onChange(value)` riceve sempre un oggetto `dayjs` (o `null` se cleared) —
 * il caller può convertirlo via `value.toDate()` o `value.format(...)`.
 */
export default function DatePicker({
  value,
  onChange,
  label,
  format = 'DD/MM/YYYY',
  fullWidth = true,
  size = 'small',
  disabled,
  required,
  helperText,
  error,
  minDate,
  maxDate,
  slotProps,
  ...rest
}) {
  // Normalizza input: accetta Date / dayjs / string / null
  const normalized = value == null ? null : dayjs.isDayjs(value) ? value : dayjs(value);

  return (
    <MuiDatePicker
      value={normalized}
      onChange={onChange}
      label={label}
      format={format}
      disabled={disabled}
      minDate={minDate ? (dayjs.isDayjs(minDate) ? minDate : dayjs(minDate)) : undefined}
      maxDate={maxDate ? (dayjs.isDayjs(maxDate) ? maxDate : dayjs(maxDate)) : undefined}
      slotProps={{
        textField: {
          fullWidth,
          size,
          variant: 'outlined',
          required,
          helperText,
          error,
          ...(slotProps?.textField ?? {}),
          sx: { ...DS_TEXTFIELD_SX, ...(slotProps?.textField?.sx ?? {}) },
        },
        ...(slotProps ?? {}),
      }}
      {...rest}
    />
  );
}
